import {uniq} from "lodash"

export default (arr, intl, max = 10) => {
  const uniqueUsers = uniq(arr)

  const elipsed = uniqueUsers.slice(0, max - 1)
  const diff = uniqueUsers.length - elipsed.length
  if (diff === 1) {
    elipsed.push(uniqueUsers[uniqueUsers.length - 1])
  } else if (diff > 1) {
    elipsed.push(intl.formatMessage({id: "recognition.utils.tooltipLimiter"}, {diff}))
  }
  return elipsed
}
